module.exports = __webpack_public_path__ + "img/contact_default.b9fe12a8.png";